import { zStringRequired } from '@/general/src/other/validation.js'
import { z } from 'zod'

export const zUpdateOrganizationForAdminEndpointInput = z.object({
  organizationId: zStringRequired,
  name: zStringRequired,
})
